export const WEEKS_IN_A_YEAR = 52;

export const MONTHS_IN_A_YEAR = 12;

export const QUARTERS_IN_A_YEAR = 4;

export const FORTNIGHTS_IN_A_YEAR = WEEKS_IN_A_YEAR / 2;

export const DEFAULT_PRECISION = 2;

export enum InputType {
  REMAINING_TERM = 'REMAINING_TERM',
  MINIMUM_REPAYMENTS = 'MINIMUM_REPAYMENTS',
  INTEREST_RATE = 'INTEREST_RATE',
}

export enum OutputType {
  REMAINING_TERM = 'remaining term',
  MINIMUM_REPAYMENTS = 'minimum repayments',
  INTEREST_RATE = 'interest rate',
}

export enum DEBT_TYPE {
  MORTGAGE = 'MORTGAGE',
  CREDIT = 'CREDIT',
  STORE = 'STORE',
  CAR = 'CAR',
  PERSONAL = 'PERSONAL',
  OTHER = 'OTHER',
}

export enum FREQUENCY {
  WEEKLY = 'WEEKLY',
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

export const ABBREVIATED_FREQUENCY: { [key: string]: string } = {
  [FREQUENCY.WEEKLY]: 'wk',
  [FREQUENCY.FORTNIGHTLY]: 'fn',
  [FREQUENCY.MONTHLY]: 'mo',
  [FREQUENCY.QUARTERLY]: 'qr',
  [FREQUENCY.YEARLY]: 'yr',
};

export enum FREQUENCY_NUMBER {
  WEEKLY = 52,
  FORTNIGHTLY = 26,
  MONTHLY = 12,
  QUARTERLY = 4,
  YEARLY = 1,
}

/**
 * Starting interest rate for calculating interest rate given term, balance and repayments.
 * Initial interest rates deliberately kept high as calculations doesn't seem to work
 * when initial interest rate estimate is much lower than the actual.
 * Could be investigated further
 */
export enum INTEREST_RATE_DEFAULT {
  MORTGAGE = 50,
  CAR = 50,
  CREDIT = 50,
  PERSONAL = 50,
  OTHER = 50,
}
